import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './services/api'; // registra o interceptor global de Accept-Language
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, useLocation } from 'react-router-dom';
import AppRoutes from './routes/app-routes';
import "./style.css"
import { FeedProvider } from "./contexts/FeedContext";
import { AlertMessage, AlertProvider, AuthProvider, ThemeProvider } from './global-components/src';
import { AnalyticsTracker } from './components/analytics-tracker';
import GlobalSeo from './components/seo/GlobalSeo';
import { AddPostProvider } from './contexts/AddPostContext';
import { VideoProvider } from './contexts/VideoContext';
import { ReactionsProvider } from './contexts/ReactionsContext';
import "./components/themes-text/copaTheme";
import "./components/themes-text/lgbtTheme";
import { loadGoogleAdsScript } from './utils/google-ads';
import ClientProtection from './components/client-protection';
import PapoWebSessionSynchronizer from './components/papo-web-session-synchronizer';

// O script global mantém os anúncios automáticos do AdSense ativos. Os slots
// manuais do feed, stories e reels reutilizam a mesma Promise/script.
void loadGoogleAdsScript().catch(error => {
  console.warn('[GoogleAds] Não foi possível carregar o AdSense.', error);
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
    <FeedProvider>
    <HelmetProvider>
      <BrowserRouter>
        <GlobalSeo />
        <AnalyticsTracker />
          <AlertProvider>
            <ClientProtection />
            <AuthProvider>
              <PapoWebSessionSynchronizer />
              <ThemeProvider>
                <AlertMessage />
                <AddPostProvider>
                  <VideoProvider>
                  <ReactionsProvider>
                    <AppRoutes />
                    </ReactionsProvider>
                  </VideoProvider>
                </AddPostProvider>
              </ThemeProvider>
            </AuthProvider>
          </AlertProvider>
      </BrowserRouter>
    </HelmetProvider>
    </FeedProvider>
); 